module.exports = __webpack_public_path__ + "img/gh_pic05-7999e3.png";